import Bookmark from '@assets/icons/bookmark.svg'
import { Icon } from './Icon'

export const BookmarkIcon = Icon(Bookmark)
